import {
    Message
} from 'element-ui'

function showMessage(type, message) {
    Message({
        message: message,
        type: type,
        duration: 2 * 1000,
        offset:400
    });
}

function showMessage_h5(type, message) {
    Message({
        message: message,
        type: type,
        duration: 2 * 1000,
        offset:0
    });
}

function successMessage(message) {
    showMessage('success', message)
}
function successMessage_h5(message) {
    showMessage_h5('success', message)
}

function warningMessage(message) {
    showMessage('warning', message)
}

function warningMessage_h5(message) {
    showMessage_h5('warning', message)
}

function errorMessage(message) {
    showMessage('error', message)
}
function errorMessage_h5(message) {
    showMessage_h5('error', message)
}

function infoMessage(message) {
    showMessage('info', message)
}

function infoMessage_h5(message) {
    showMessage_h5('info', message)
}

function showToast(msg, type) {
    if (type === 'warning') {
        this.$message({
            message: msg,
            type: type
        });
    } else if (type === 'error') {
        this.$message.error(msg);
    } else {
        this.$message({
            message: msg,
            type: 'success'
        });
    }
}

function showConfirm(msg, callBack, type) {
    this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type ? type : 'warning'
    }).then(() => {
        callBack()
    }).catch(() => {

    })
}

export {
    warningMessage,
    errorMessage,
    successMessage,
    infoMessage,
    showToast,
    showConfirm,
    warningMessage_h5,
    successMessage_h5,
    errorMessage_h5,
    infoMessage_h5
}


// WEBPACK FOOTER //
// ./src/utils/message.js